module.exports = "<a l10n=\"\" ng-click=$ctrl.navigateToRulesPage()>Rules</a>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/flight-rules-link/flight-rules-link.html
// module id = 907
// module chunks = 0